/* global axios */
import ApiClient from '../ApiClient';

class PilotLeadCaptureStates extends ApiClient {
  constructor() {
    super('pilot/lead_capture_states', { accountScoped: true });
  }

  get({ page = 1 } = {}) {
    return axios.get(this.url, { params: { page } });
  }

  retry(id, payload) {
    return axios.post(`${this.url}/${id}/retry`, { payload });
  }
}

export default new PilotLeadCaptureStates();
